import { render } from "./NoRecordScreen.vue?vue&type=template&id=05e9ff71"
import script from "./NoRecordScreen.vue?vue&type=script&lang=js"
export * from "./NoRecordScreen.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__